import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class NewsletterLogic extends Component {

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
  }

  subscribeNewsletter(url, jsonBody) {
    const response = fetch(`${url}?newsletter-subscription=true`, {
      method: 'POST',
      body: jsonBody
    })
    .catch(error => console.error('Error subscription:', error));
    return response;
  }

  afterSubscription(component) {
    let ctx = component;
    // elems
    let thanksTitle = ctx.$component.querySelector(ctx.SELECTORS.thanksTitle);
    if ( thanksTitle != null ) {
      let thanksTitleString = thanksTitle.getAttribute('data-attr');
      if ( thanksTitleString != null ) {
        let thanksTitleContent = thanksTitleString.replace('{%1}', ctx.$component.querySelector(ctx.SELECTORS.firstName).value);
        // put thanks label
        thanksTitle.innerHTML = thanksTitleContent;
      }
    }
  }

  render() {
    this.log('Load logics...');
  }
}
